var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDissociateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5415 15.0729L13.5415 2.5625L11.4582 2.5625L11.4582 15.0729L8.33317 15.0729L12.4998 19.2292L16.6665 15.0729L13.5415 15.0729Z",
    fill: "#071E31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05996 7.62156C6.37527 8.59806 5.05947 10.1027 4.31626 11.9025C3.57306 13.7024 3.44391 15.697 3.94881 17.5777C4.4537 19.4583 5.56448 21.1201 7.10918 22.3057C8.65388 23.4913 10.5463 24.1346 12.4936 24.1361C14.4408 24.1375 16.3342 23.497 17.8807 22.3137C19.4272 21.1304 20.5404 19.4703 21.0481 17.5904C21.5558 15.7105 21.4296 13.7156 20.6891 11.9147C19.9485 10.1138 18.635 8.60717 16.9517 7.62816L16.2594 8.81855C17.6808 9.64529 18.7901 10.9176 19.4154 12.4384C20.0408 13.9592 20.1474 15.6438 19.7186 17.2313C19.2899 18.8188 18.3498 20.2208 17.0439 21.22C15.7379 22.2193 14.139 22.7602 12.4946 22.759C10.8502 22.7578 9.2521 22.2145 7.94764 21.2133C6.64319 20.2121 5.70517 18.8088 5.2788 17.2206C4.85243 15.6325 4.9615 13.948 5.58911 12.4281C6.21672 10.9082 7.32787 9.6376 8.75055 8.81297L8.05996 7.62156Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDissociateIcon);
export default __webpack_public_path__ + "static/media/dissociate-icon.b8afad3f2a5c540ae714613327938190.svg";
export { ForwardRef as ReactComponent };